import { ComponentProps, ComponentType, JSX, PureComponent } from "react";

import { SvgConstantPositiveTheme } from "../SvgConstants";
import { InjectedSvgProps } from "./hocTypings";
import { getDisplayName } from "./utils";

export function asPositiveSvg<
  C extends ComponentType<ComponentProps<C> & InjectedSvgProps>,
  ResolvedProps = JSX.LibraryManagedAttributes<C, ComponentProps<C>>
>(WrappedComponent: C) {
  return class AsPositiveSvg extends PureComponent<
    ResolvedProps & InjectedSvgProps
  > {
    static displayName = `asPositiveSvg(${getDisplayName(WrappedComponent)})`;

    static defaultProps = {
      fillColor: SvgConstantPositiveTheme.fill,
      secondaryFillColor: SvgConstantPositiveTheme.secondaryFill,
      className: "ddbc-svg--positive",
    };

    render() {
      return <WrappedComponent {...(this.props as any)} />;
    }
  };
}
